import { render, staticRenderFns } from "./DashboardCaseSessions.vue?vue&type=template&id=3446e8f0&scoped=true"
import script from "./DashboardCaseSessions.vue?vue&type=script&lang=js"
export * from "./DashboardCaseSessions.vue?vue&type=script&lang=js"
import style0 from "./DashboardCaseSessions.vue?vue&type=style&index=0&id=3446e8f0&prod&lang=scss"
import style1 from "./DashboardCaseSessions.vue?vue&type=style&index=1&id=3446e8f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3446e8f0",
  null
  
)

export default component.exports